import { render, staticRenderFns } from "./MailingTemplatesPage.vue?vue&type=template&id=a4ef8178&scoped=true&"
import script from "./MailingTemplatesPage.vue?vue&type=script&lang=js&"
export * from "./MailingTemplatesPage.vue?vue&type=script&lang=js&"
import style0 from "./MailingTemplatesPage.vue?vue&type=style&index=0&id=a4ef8178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ef8178",
  null
  
)

export default component.exports